/**
 * Shim for @clariness/modal: re-exports with Body/Header/Footer typed to accept children (React 19).
 */
import React from 'react';
import {
  Modal as OrigModal,
  useModal,
  ModalProvider,
  type ModalProps,
} from '~clariness-modal';

export { useModal, ModalProvider };
export type { ModalProps };

type BodyProps = { children?: React.ReactNode; sx?: Record<string, unknown> };
type FooterProps = { children?: React.ReactNode; sx?: Record<string, unknown> };
type HeaderProps = { children?: React.ReactNode; [key: string]: unknown };

export const Modal = OrigModal as typeof OrigModal & {
  Body: React.FC<BodyProps>;
  Header: React.FC<HeaderProps>;
  Footer: React.FC<FooterProps>;
};
